var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "news-list", style: _vm.containerStyle }, [
    _c("div", { staticClass: "news", style: { width: _vm.width } }, [
      _c("div", { staticClass: "news-tit", staticStyle: { display: "flex" } }, [
        _c("span", { staticStyle: { color: "#000000" } }, [_vm._v("搜索结果")]),
        _c("i", {
          staticClass: "el-icon-close",
          staticStyle: { color: "#67686b" },
          on: { click: _vm.closeNewsList },
        }),
      ]),
      _c(
        "div",
        { staticStyle: { flex: "1", height: "calc(100% - 60px)" } },
        [
          _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              { staticClass: "news-content" },
              _vm._l(_vm.getNewsList(), function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.url,
                    staticClass: "news-item",
                    on: {
                      click: function ($event) {
                        return _vm.openNewsUrl(item.url)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item-tit",
                        staticStyle: { display: "flex" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "item-new-tit ellipsis ellipsis-1" },
                          [_vm._v(" " + _vm._s(item.title) + " ")]
                        ),
                        _c("div", { staticClass: "item-tit-rg" }, [
                          _vm._v(_vm._s(item.id)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "item-new-dec ellipsis ellipsis-2" },
                      [_vm._v(" " + _vm._s(item.content) + " ")]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }